/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Run_NextInputs */

const en_inbox_na_run_next = /** @type {(inputs: Inbox_Na_Run_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build the next step`)
};

const id_inbox_na_run_next = /** @type {(inputs: Inbox_Na_Run_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangunkan langkah berikutnya`)
};

/**
* | output |
* | --- |
* | "Build the next step" |
*
* @param {Inbox_Na_Run_NextInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_run_next = /** @type {((inputs?: Inbox_Na_Run_NextInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Run_NextInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_run_next(inputs)
	return en_inbox_na_run_next(inputs)
});